(() => {
  const mainContent = document.getElementById('MainContent');

  if (mainContent) {
    mainContent.setAttribute('data-hydrated', '');
  }

  window.__forgeCartDrawerOpen = (dialog) => {
    if (dialog && typeof dialog.showDialog === 'function') {
      dialog.showDialog();
    }

    if (typeof customElements !== 'undefined') {
      customElements.whenDefined('shopify-payment-terms').then(() => {
        const paymentTerms = document.querySelector('shopify-payment-terms');
        const installmentsCta =
          paymentTerms?.shadowRoot?.querySelector('#shopify-installments-cta');

        if (
          installmentsCta &&
          dialog &&
          typeof dialog.closeDialog === 'function'
        ) {
          installmentsCta.addEventListener('click', dialog.closeDialog, {
            once: true,
          });
        }
      });
    }
  };
})();